import React from 'react'
import { Redirect, Route } from 'react-router-dom'

import { useAuth } from '@peracto/peracto-auth'

const PrivateRoute = ({ component: Component, render = null, ...rest }) => {
    const { user } = useAuth()

    return (
        <Route
            {...rest}
            render={props => {
                if (!user.authenticated) {
                    return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
                }

                if (render && typeof render === 'function') {
                    return render(props)
                }

                return <Component {...props} />
            }}
        />
    )
}

export default PrivateRoute
